import { Injectable } from '@angular/core';
import { createClient, Entry } from 'contentful';

import { init as initContentfulApp } from '@contentful/app-sdk';

const CONFIG = {
  space: '***********',
  accessToken: '**********',
  contentTypeIds: {
    stop: 'stop',
    imageBreak: 'imageBreak',

  }
}

const stopData = {
  banner: {
    alt: "",
    url: ""
  },
  intro: "",
  name: "",
  slug: "",
  info: []
}

initContentfulApp((sdk:any) => {
  console.log(sdk);
});

// stop: '7o4W62WHBZajewvbgi1Py7',
//     banner: '7o4W62WHBZajewvbgi1Py7',
//     quiz: '7o4W62WHBZajewvbgi1Py7',
//     timeBar: '7o4W62WHBZajewvbgi1Py7',

@Injectable({
  providedIn: 'root'
})
export class ContentfulService {
  private cdaClient = createClient({
    space: CONFIG.space,
    accessToken: CONFIG.accessToken
  });

  constructor() { }

  getImageBreaks(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.imageBreak
    }, query)).then(res => res.items);
  }

  getStop(index: number, query?: object): Promise<Object> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.stop
    }, query)).then(res => {
      let data: any = res.items[0];
      let bannerData = data.fields.banner.fields;
      stopData.banner = {
        alt: bannerData.alternativeText,
        url: "https://"+bannerData.image.fields.file.url.slice(2)
      };
      stopData.intro = data.fields.intro;
      stopData.name = data.fields.name;
      stopData.slug = data.fields.slug;
      let infoDataArray = data.fields.info.content;
      for (let i=0; i<infoDataArray.length; i++) {
        let infoData = infoDataArray[i];
        if (infoData.nodeType == "heading-2") {
          stopData.info.push({ title: infoData.content[0].value, pt: 3});
        } else if (infoData.nodeType == "paragraph" && i != infoDataArray.length-1) {
          if (infoData.content.length > 1) {
            let paragraph = "";
            // console.log(infoData.data);
            // console.log(infoData.content[0].marks);
            
            for (let j=0; j<infoData.content.length; j++) {
              let marks = [];
              let paragraphData = infoData.content[j];
              // console.log(paragraphData);
              // console.log(paragraphData.marks);
              for(let k=0; k<paragraphData.marks.length; k++) {
                marks.push(paragraphData.marks[k].type);
                switch (paragraphData.marks[k].type) {
                  case 'bold':
                    paragraph += "<strong>";
                    break;
                  case 'italic':
                    paragraph += "<i>";
                    break;
                  case 'underline':
                    paragraph += "<u>";
                    break;
                }
              }
              paragraph += paragraphData.value;
              for (let k=0; k<marks.length; k++) {
                switch (marks[k]) {
                  case 'bold':
                    paragraph += "</strong>";
                    break;
                  case 'italic':
                    paragraph += "</i>";
                    break;
                  case 'underline':
                    paragraph += "</u>";
                    break;
                }
              }
            }
            // console.log(paragraph);
            stopData.info.push({ p: paragraph, pt: 3});
          } else {
            let paragraphData = infoData.content[0];
            let paragraph = "";
            let marks = [];
            for (let j=0; j<paragraphData.marks.length; j++) {
              marks.push(paragraphData.marks[j].type);
              switch (paragraphData.marks[j].type) {
                case 'bold':
                  paragraph += "<strong>";
                  break;
                case 'italic':
                  paragraph += "<i>";
                  break;
                case 'underline':
                  paragraph += "<u>";
                  break;
              }
            }
            paragraph += paragraphData.value;
            for (let k=0; k<marks.length; k++) {
              switch (marks[k]) {
                case 'bold':
                  paragraph += "</strong>";
                  break;
                case 'italic':
                  paragraph += "</i>";
                  break;
                case 'underline':
                  paragraph += "</u>";
                  break;
              }
            }
            stopData.info.push({ p: paragraph, pt: 3});
          }
        } else if (infoData.nodeType == "embedded-entry-block") {
          let contentType = infoData.data.target.sys.contentType.sys.id;
          if (contentType == "imageBreak") {
            let imageData = infoData.data.target.fields;
            if (imageData.images.length == 1) {
              stopData.info.push({
                img: {
                  size: imageData.size,
                  url: "https://"+imageData.images[0].fields.file.url.slice(2),
                  footnote: imageData.footnotes[0],
                  alt: imageData.alternativeText[0]
                },
                pt: 2
              });
            } else {
              stopData.info.push({
                double_img: {
                  url_a: "https://"+imageData.images[0].fields.file.url.slice(2),
                  footnote_a: imageData.footnotes[0],
                  alt_a: imageData.alternativeText[0],
                  url_b: "https://"+imageData.images[1].fields.file.url.slice(2),
                  footnote_b: imageData.footnotes[1],
                  alt_b: imageData.alternativeText[1]
                },
                pt: 2
              });
            }
          } else if (contentType == "timeBar") {
            let timeBarData = infoData.data.target.fields;
            stopData.info.push({
              timebar: {
                date: timeBarData.date,
                title: timeBarData.title
              }
            });
          } else if (contentType == "quiz") {
            let quizData = infoData.data.target.fields;
            stopData.info.push({
              quiz: {
                question: quizData.question,
                choices: quizData.choices,
                answer: quizData.answer
              }
            });
          }
        }
      }
      // console.log(res);
      return stopData;
    });
  }
}
